export const formatSAR = (n, opts = {}) => {
  const { compact = false, withSymbol = true } = opts;
  if (n === null || n === undefined || Number.isNaN(n)) return '—';
  const formatter = new Intl.NumberFormat('en-SA', {
    notation: compact ? 'compact' : 'standard',
    maximumFractionDigits: compact ? 1 : 0,
  });
  const v = formatter.format(n);
  return withSymbol ? `SAR ${v}` : v;
};

export const formatNumber = (n, opts = {}) => {
  if (n === null || n === undefined) return '—';
  return new Intl.NumberFormat('en-SA', { maximumFractionDigits: opts.digits ?? 0 }).format(n);
};

export const formatPct = (n, digits = 1) => `${(n ?? 0).toFixed(digits)}%`;

export const formatDate = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateTime = (iso) => {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
};

export const timeAgo = (iso) => {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const maskId = (id) => {
  if (!id) return '—';
  return `${id.slice(0, 1)}${'*'.repeat(Math.max(id.length - 3, 0))}${id.slice(-2)}`;
};

export const maskPhone = (p) => {
  if (!p) return '—';
  return p.replace(/(\+?\d{4})(\d+)(\d{3})/, (_, a, b, c) => `${a}${'*'.repeat(b.length)}${c}`);
};
